import React from 'react';
import Button, { ButtonProps } from './Button';
import { Row } from './RowCol';
import Spacer from './Spacer';

type Props = ButtonProps & {
	confirmOnNextLine?: true;
}

type State = {
	confirming: boolean;
}

class ConfirmableButton extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			confirming: false,
		};
	}

	render() {
		const {
			label,
			onClick,
			small,
		} = this.props;

		const { confirming } = this.state;

		if (confirming) {
			return (
				<Row>
					<div style={{
						padding: '8px 30px',
						fontFamily: 'Korinna',
						textTransform: 'uppercase',
						fontSize: '24px',
						whiteSpace: 'nowrap',
						...small ? {
							padding: '4px 15px',
							fontSize: '12px',
						} : {}
					}}>
						{label}
						{'?'}
					</div>
					<Spacer horizontal={5} />
					<Button
						label="Confirm"
						onClick={() => {
							this.setState({
								confirming: false,
							}, onClick);
						}}
						small={small}
					/>
					<Spacer horizontal={5} />
					<Button
						label="Cancel"
						onClick={() => this.setState({
							confirming: false,
						})}
						small={small}
					/>
				</Row>
			);
		}

		return (
			<Button
				label={label}
				onClick={() => this.setState({
					confirming: true,
				})}
				small={small}
			/>
		);
	}
}

export default ConfirmableButton;
